import { Handbook } from '@/classes/Handbook'
const url = '/pto/handbook/'

const PTO_HANDBOOK_LIST = {
  'production-type': new Handbook({
    pageTitle: 'Вид производства',
    nameHandbook: 'production-type',
    vuexModuleNamespaced: 'productionType',
    url
  }),
  'product-type': new Handbook({
    pageTitle: 'Вид продукции',
    nameHandbook: 'product-type',
    vuexModuleNamespaced: 'productType',
    url
  }),
  'job-type': new Handbook({
    pageTitle: 'Виды работ',
    nameHandbook: 'job-type',
    vuexModuleNamespaced: 'jobType',
    url
  }),
  'measure-unit': new Handbook({
    pageTitle: 'Единицы измерения',
    nameHandbook: 'measure-unit',
    vuexModuleNamespaced: 'measureUnit',
    url
  }),
  'id-handbook': new Handbook({
    pageTitle: 'ИД',
    nameHandbook: 'id-handbook',
    vuexModuleNamespaced: 'idHandbook',
    url
  }),
  'nomenclature-type': new Handbook({
    pageTitle: 'Наименование номенклатуры',
    nameHandbook: 'nomenclature-type',
    vuexModuleNamespaced: 'nomenclatureType',
    url
  }),
  'nomenclature-standard': new Handbook({
    pageTitle: 'Стандарты',
    nameHandbook: 'nomenclature-standard',
    vuexModuleNamespaced: 'nomenclatureStandard',
    url
  }),
  'document-status': new Handbook({
    pageTitle: 'Статус документа',
    nameHandbook: 'document-status',
    vuexModuleNamespaced: 'documentStatus',
    url
  }),
  'object-status': new Handbook({
    pageTitle: 'Статус объекта',
    nameHandbook: 'object-status',
    vuexModuleNamespaced: 'statusObject',
    url
  }),
  'project-status': new Handbook({
    pageTitle: 'Статус проекта',
    nameHandbook: 'project-status',
    vuexModuleNamespaced: 'statusProject',
    url
  }),
  'statement-type': new Handbook({
    pageTitle: 'Тип деф. ведомости',
    nameHandbook: 'statement-type',
    vuexModuleNamespaced: 'statementType',
    url
  }),
  'document-file-type': new Handbook({
    pageTitle: 'Тип файла документа',
    nameHandbook: 'document-file-type',
    vuexModuleNamespaced: 'documentFileType',
    url
  }),
  'fot-surcharges': new Handbook({
    pageTitle: 'ФОТ',
    nameHandbook: 'fot-surcharges',
    vuexModuleNamespaced: 'fotSurcharges',
    url
  }),
  'сost-person-hour': new Handbook({
    pageTitle: 'Стоимость чел/час',
    nameHandbook: 'сost-person-hour',
    vuexModuleNamespaced: 'сostPersonHour',
    url
  })
}

export {
  PTO_HANDBOOK_LIST
}
